
  <template>
     <v-alert
      :type="tipo"
      :title="titulo"
      :text="descripcion"
      closable
    ></v-alert>
  </template>
  
  <script>
  export default {
  props:{
    tipo:{
    type: String,
    default: ''
  },
    titulo:{
    type: String,
    default: ''
  },
    descripcion:{
    type: String,
    default: ''
  }
  }
  }
  </script>
  
  <style>
  
  </style>